import React, { Component } from 'react';

import { Badge } from 'react-bootstrap';

class CommonBadgeOptions extends Component {

    render() {
        const { text, options, id, icon, inlineClass = '' } = this.props;
        const found = options.find(option => option.id === id);

        if (!found) return null;

        return (
            <Badge 
                bg={found.variant || 'secondary'}
                className={`${inlineClass}`}
                pill
            >
                {(found.icon && icon === true) && <i className={`${found.icon} me-1`}></i>}
                {text}
            </Badge>
        );
    }
}

export default CommonBadgeOptions;
